var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85714 1H1.90909C1.40701 1 1 1.40701 1 1.90909C1 6.92986 5.07014 11 10.0909 11C10.593 11 11 10.593 11 10.0909V8.14286L8.85714 6.71429L7.74602 7.82541C7.55303 8.0184 7.26462 8.07842 7.02214 7.95316C6.61089 7.74071 5.94355 7.34153 5.28571 6.71429C4.6122 6.07209 4.21758 5.3801 4.01951 4.96135C3.90851 4.72667 3.97277 4.4558 4.15634 4.27224L5.28571 3.14286L3.85714 1Z",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.08da62f5b7b52ab10ac4afe30e0bae4d.svg";
export { ForwardRef as ReactComponent };